<template>
  <div class="box">
    <showpdf v-if="showPdf" @close='closePdf()' :url="url"></showpdf>
    <van-image v-if="type == '1'" width="100%" height="100%" :src="url" />
    <video v-if="type == '2'" width="100%" height="240" controls>
      <source :src="url" type="video/mp4">
    </video>
    <div v-if="type == '3'">
    </div>
  </div>
</template>
<script>
import { geturl } from '@/utils/index';
import { getWechatCardContent, getId, } from '@/api/index'
import showpdf from './pdf/index'
export default {
  name: 'Home',
  components: {
    showpdf
  },
  data() {
    return {
      type: '',
      id: '',
      taskId: '',
      wechatId: '',
      url: '',
      showPdf: false,
    };
  },
  mounted() {
    let params = geturl()
    console.log(params.type);
    this.type = params.type
    this.id = params.wechatCardId
    this.taskId = params.taskId
    this.wechatId = params.wechatId
    console.log(this.type, this.id, this.taskId, this.wechatId);
    this.getaddleId()
    this.getList()
  },
  methods: {
    getList() {
      getWechatCardContent({ id: this.id }).then(res => {
        this.url = res.content
        // 如果是pdf 打开pdf
        window.location.href = res.content
      })
    },
    closePdf() {
      this.showPdf = false
    },
    getaddleId() {
      let params = {
        taskId: this.taskId,
        wechatUserIp: JSON.stringify({ "wxid": this.wechatId, "IP": " " }),
      }
      getId(params).then(res => {
        console.log(res)
      })
    }
  },

}
</script>

<style lang="less" scoped>
.box {
  padding: 20px;
}
</style>